import { cn } from "@/lib/utils";

/**
 * The signature element: a stat as it would read on a stadium board.
 * `lit` = bulb-amber digits on navy (new / live). Unlit = quiet, for history.
 */
export function ScoreboardTile({
	value,
	abbr,
	lit = true,
	className,
}: {
	value: number | string;
	abbr: string;
	lit?: boolean;
	className?: string;
}) {
	return (
		<div
			className={cn(
				"flex min-h-[4.75rem] w-16 shrink-0 flex-col items-center justify-center gap-1 self-start rounded-lg px-2 py-2.5 sm:w-[4.75rem]",
				lit ? "bg-board text-signal" : "bg-muted text-foreground",
				className,
			)}
		>
			<span
				className={cn(
					"type-stat text-[1.875rem] sm:text-[2.25rem]",
					lit &&
						"[text-shadow:0_0_14px_color-mix(in_oklch,var(--signal)_45%,transparent)]",
				)}
			>
				{value}
			</span>
			<span
				className={cn(
					"type-data text-[0.625rem] leading-none tracking-wider",
					lit ? "text-board-label" : "text-muted-foreground",
				)}
			>
				{abbr}
			</span>
		</div>
	);
}
